
/**
 * @fileOverview GlobalResizeListener Creates a single instance of the Resize Listener that can be accessed by other
 * modules as needed.  This is preferable to including mutliple resize listeners, as they would broadcast events multiple
 * times to the same channel causing shinanigans.
 *
 * @author Jeff Maki <jmaki@nerdery.com>
 *
 * NOTE: THIS REQUIRE MODULE IS NAME SPACED, AND NEEDS TO HAVE ITS WRAPPER FUNCTION REMOVED IN ORDER TO REUSE ELSEWHERE *
 *
 * @version 1.0
 */

(function (context) {
    'use strict';

    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('GlobalResizeListener',['require','models/ResizeListener'],function (require) {

        var ResizeListener = require('models/ResizeListener');

        /**
         * Traps an instance of the resize listener for us to use in other components
         *
         * @constructor
         * @static
         */
        var GlobalEventDispatcher = {};

        GlobalEventDispatcher.resizeListener = new ResizeListener(100);

        /**
         * Returns the local instance of an ResizeListener
         *
         * @return {ResizeListener}
         */
        GlobalEventDispatcher.getResizeListener = function () {
            return this.resizeListener;
        };

        return GlobalEventDispatcher;
    });

}(MMMRequire));